import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Box } from '@mui/system';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteItemDialog = ({open, handleClose, itemDelete, handleDeleteItem}) => {
  const handleDelete = () => {
    handleDeleteItem(itemDelete);
  }
  return (
    <div>
      {itemDelete && <Dialog open={open} onClose={handleClose} TransitionComponent={Transition} sx={{width: "100vw"}}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose}><CloseIcon /></IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Delete Item</Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              Do you want to delete ?
            </Grid>
            <Grid item xs={12}><Button autoFocus variant="contained" onClick={handleDelete} fullWidth>Delete</Button></Grid>
          </Grid>
        </Box>
      </Dialog>}
    </div>
  )
}

export default DeleteItemDialog
